import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class HydrationGuard extends Vue {
  hydrating = false;
  loaded = false;

  get busy(): boolean {
    return !this.loaded || this.hydrating;
  }

  async hydrate(isi: () => Promise<void>): Promise<void> {
    this.hydrating = true;

    try {
      await isi();
    } finally {
      this.loaded = true;

      this.$nextTick(() => {
        this.hydrating = false;
      });
    }
  }
}
